import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { boostersFontCss } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { BuyBoosters } from '../common/buy-boosters'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
import type { ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

type BuyBoostersDialogProps = {
  currency: CurrencyModel
  premium: PremiumMetaModel
} & ClassNameProps &
  DialogControlProps

export const BuyBoostersDialog: React.FC<BuyBoostersDialogProps> = ({
  className,
  currency,
  premium,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()
  return (
    <PremiumDialog
      open={open}
      onOpenChange={onOpenChange}
      title={
        <span>
          <Trans
            i18nKey={'premium.pay.boosters.title'}
            components={[<StyledTitle key={0} />]}
          />
        </span>
      }
      describedBy={t('premium.pay.boosters.title')}
      onClose={() => {
        onOpenChange?.(false)
      }}
      className={className}
    >
      <BuyBoosters
        onClose={() => {
          onOpenChange?.(false)
        }}
        currency={currency}
        premium={premium}
        device="desktop"
      />
    </PremiumDialog>
  )
}

const StyledTitle = styled.span`
  ${boostersFontCss}
`
